
import { Prop, Vue, Component } from 'vue-property-decorator';
import CategoryItem from './CategoryItem.vue';

interface Category {
    name: string;
    subcategories?: Category[];
}

@Component({
    components: { CategoryItem }
})
export default class CategoryTree extends Vue {
    @Prop({ required: true }) readonly categories!: Category[];
}
